import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import WalkingDistanceCalculator from './components/WalkingDistanceCalculator';

const App: React.FC = () => {
  return (
    <Router>
      <div className="font-sans m-5 leading-relaxed text-gray-800">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/walking-distance" element={<WalkingDistanceCalculator />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
